<section class="content delay-page">
  <div class="content-block">
    <app-breadcrumb [title]="'delaysCatalog.breadcrumb.title' | translate"
                    [items]="['delaysCatalog.breadcrumb.section' | translate]"
                    [active_item]="'delaysCatalog.breadcrumb.title' | translate" />

    <div class="delay-filters">
      @if (companies.length > 1) {
      <app-company-select class="delay-filter-field" [records]="companies"
                          [value]="filters.companiesRecordId" [includeAll]="true"
                          [label]="'orgUnitsCatalog.fields.company' | translate"
                          [placeholder]="'delaysCatalog.filters.allCompanies' | translate"
                          [allLabel]="'delaysCatalog.filters.allCompanies' | translate"
                          (valueChange)="filters.companiesRecordId = $event; onCompanyChanged()" />
      }

      <app-org-unit-tree-select class="delay-filter-field"
                                [units]="orgUnits"
                                [value]="filters.orgUnitId"
                                [placeholder]="'delaysCatalog.filters.allOrgUnits' | translate"
                                [searchPlaceholder]="'employeesCatalog.orgUnitPicker.searchPlaceholder' | translate"
                                (valueChange)="filters.orgUnitId = $event; onOrgUnitChanged()" />

      <mat-form-field class="delay-filter-field" appearance="outline" subscriptSizing="dynamic">
        <mat-icon matPrefix>badge</mat-icon>
        <input matInput
               [placeholder]="'delaysCatalog.filters.employeePlaceholder' | translate"
               [ngModel]="employeeSearchText"
               (ngModelChange)="onEmployeeInput($event)"
               [matAutocomplete]="employeeAutocomplete" />
        <mat-autocomplete #employeeAutocomplete="matAutocomplete"
                          [displayWith]="displayEmployee"
                          (optionSelected)="onEmployeeSelected($event)">
          @for (employee of employees; track employee.employeeId) {
            <mat-option [value]="employee">{{ displayEmployee(employee) }}</mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>

      <div class="delay-week-filter">
        <button mat-icon-button type="button" (click)="changeWeek(-1)"
                [attr.aria-label]="'delaysCatalog.actions.previousWeek' | translate">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <app-date-time-picker-field class="delay-date-filter"
                                    [label]="'delaysCatalog.filters.week' | translate"
                                    [value]="filters.weekDate"
                                    mode="date"
                                    (valueChange)="onWeekDateChanged($event)" />
        <button mat-icon-button type="button" (click)="changeWeek(1)"
                [attr.aria-label]="'delaysCatalog.actions.nextWeek' | translate">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>

      <div class="delay-filters__actions">
        <button mat-icon-button type="button" class="delay-refresh-button" (click)="refreshTable()"
                [disabled]="isLoading" [attr.aria-label]="'common.refresh' | translate">
          <mat-icon [class.is-spinning]="isLoading">refresh</mat-icon>
        </button>
        <button mat-icon-button type="button" class="delay-clear-button" (click)="clearFilters()"
                [attr.aria-label]="'delaysCatalog.actions.clear' | translate">
          <mat-icon>filter_alt_off</mat-icon>
        </button>
      </div>
    </div>

    <div class="delay-list-card">
      @if (isLoading) {
        <app-loading-state [overlay]="false" [message]="'delaysCatalog.loading' | translate" />
      } @else if (!rows.length) {
        <div class="delay-empty">
          <span><mat-icon>schedule</mat-icon></span>
          <h3>{{ 'delaysCatalog.empty.title' | translate }}</h3>
          <p>{{ 'delaysCatalog.empty.description' | translate }}</p>
        </div>
      } @else {
        <div class="delay-list-scroll">
          <table class="delay-list">
            <thead>
              <tr>
                <th class="delay-employee-column">{{ 'delaysCatalog.table.employee' | translate }}</th>
                <th>{{ 'delaysCatalog.table.detectedDelays' | translate }}</th>
                <th class="delay-total-column">{{ 'delaysCatalog.table.weekTotal' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (row of rows; track row.employeeId) {
                <tr>
                  <td class="delay-employee-column">
                    <div class="delay-employee">
                      <span class="delay-avatar">{{ row.employeeName.charAt(0) }}</span>
                      <div>
                        <strong>{{ row.employeeName }}</strong>
                        <span>{{ row.employeeNumber }}</span>
                        <small>{{ row.orgUnitName }}</small>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="delay-events">
                      @for (item of delaysForRow(row); track item.result.attendanceResultId) {
                        <article class="delay-event" [class.delay-event--justified]="hasJustification(item.result)">
                          <span class="delay-event__date">
                            <strong>{{ item.day.weekday }}</strong>
                            {{ item.day.dayLabel }}
                          </span>
                          <span class="delay-event__status">
                            <mat-icon>schedule</mat-icon>
                            <span>
                              <strong>
                                {{ (hasJustification(item.result) ? 'delaysCatalog.status.justified' : 'delaysCatalog.status.delayed') | translate }}
                                · {{ delayMinutes(item.result) }} {{ 'delaysCatalog.table.minutesShort' | translate }}
                              </strong>
                              <small>{{ 'delaysCatalog.table.entry' | translate }} {{ entryTime(item.result) }}</small>
                            </span>
                          </span>
                          @if (!hasJustification(item.result) && canCreateJustification) {
                            <button mat-icon-button type="button" (click)="createJustification(item.result)"
                                    [attr.aria-label]="'delaysCatalog.actions.justify' | translate">
                              <mat-icon>note_add</mat-icon>
                            </button>
                          } @else {
                            <button mat-icon-button type="button" (click)="viewResult(item.result)"
                                    [attr.aria-label]="'delaysCatalog.actions.view' | translate">
                              <mat-icon>visibility</mat-icon>
                            </button>
                          }
                        </article>
                      }
                    </div>
                  </td>
                  <td class="delay-total-column">
                    <span class="delay-total">{{ totalDelayMinutes(row) }}</span>
                    <small>{{ 'delaysCatalog.table.minutes' | translate }}</small>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <mat-paginator [length]="totalItems"
                       [pageIndex]="currentPage - 1"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="[25, 50, 100]"
                       showFirstLastButtons
                       (page)="onPageChange($event)" />
      }
    </div>
  </div>
</section>
